import React from 'react';
import { t } from '@lingui/macro';
// eslint-disable-next-line import/no-unresolved
import { GroupBase } from 'react-select/dist/declarations/src/types';
import { components, MultiValueRemoveProps } from 'react-select';

const MultiValueRemove = <Option extends { label: string }, IsMulti extends boolean, Group extends GroupBase<Option>>({
  data,
  innerProps,
  selectProps,
}: MultiValueRemoveProps<Option, IsMulti, Group>) => {
  const myInnerProperties = { ...innerProps, 'aria-label': t`Remove ${data.label}` };
  return <components.MultiValueRemove data={data} innerProps={myInnerProperties} selectProps={selectProps} />;
};

export default MultiValueRemove;
